import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { SearchPageNames } from 'ep-bt-controls';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';
import { EpbtFaDocumentService } from '../../services/epbt-fa-document.service';

@Component({
  selector: 'epbt-fa-sort-list',
  templateUrl: './epbt-fa-sort-list.component.html',
  styleUrls: ['./epbt-fa-sort-list.component.scss']
})
export class EpbtFaSortListComponent implements OnChanges, OnInit {

  dropdownList: Array<{ text: string; value: string }> = [];
  @Input() labelText: string = "";
  @Input() pageName: string;

  private _selectedSortValue: string;
  @Input('selectedSortValue') set selectedSortValue(value: string) {
    this._selectedSortValue = value;
    if (this._selectedSortValue) {
      var result = this.dropdownList.filter(x => x.value == this._selectedSortValue);
      this.sortValueChange.emit(result ? result[0] : null);
    }
  }
  get selectedSortValue(): string {
    return this._selectedSortValue;
  }

  @Output() sortValueChange = new EventEmitter<any>();

  constructor(private sortService: EpbtFaSortService, private faDocumentService: EpbtFaDocumentService) { }

  ngOnChanges(changes: SimpleChanges) {
    const pageName: SimpleChange = changes.pageName;
    if (pageName) {
      this.pageName = pageName.currentValue;
      this.getDropdownData();
    }
  }

  ngOnInit() {
  }

  onSelectionChange(selectedValue: any) {
    if (selectedValue) {
      this.selectedSortValue = selectedValue;
      var result = this.dropdownList.filter(x => x.value == this.selectedSortValue);
      this.sortValueChange.emit(result ? result[0] : null);
    }
  }

  getDropdownData() {
    switch (this.sortService.currentPageName) {
      case SearchPageNames.CustomerSearch:
        {
          this.dropdownList = [{ text: 'Name', value: 'Name' },
          { text: 'Code', value: 'CustomerCode' },
          { text: 'Phone', value: 'Telephone1' },
          { text: 'Mobile', value: 'Mobile' },
          { text: 'Email', value: 'Email' }];
          break;
        }
      case SearchPageNames.CustomerDetailsSearch: { break; }
      case SearchPageNames.ProductSearch:
        {
          this.dropdownList = [{ text: 'Best match', value: 'Bestmatch' },
          { text: 'Price', value: 'StandardSellPrice' },
          { text: 'Product code', value: 'ProductCode' }];
          break;
        }
      case SearchPageNames.ProductDetailsSearch: { break; }
      case SearchPageNames.BinLocationProductSearch: { break; }
      case SearchPageNames.SuppliersSearch:
        {
          this.dropdownList = [{ text: 'Name', value: 'Name' },
          { text: 'Supplier Code', value: 'Code' },
          { text: 'Phone', value: 'Phone' },
          { text: 'Email', value: 'Email' },
          { text: 'Contact', value: 'ContactName' },
          { text: 'ContactNumber', value: 'ContactNumber' }];
          break;
        }
      case SearchPageNames.CustomerAddressSearch:
        {
          this.dropdownList = [{ text: 'Address Code', value: 'AddressCode' },
          { text: 'Contact Name', value: 'ContactName' }];
          break;
        }
      case SearchPageNames.DashboardContactSearch:
        {
          this.dropdownList = [{ text: 'Name', value: 'Name' },
          { text: 'Customer Code', value: 'CustomerCode' },
          { text: 'Customer Name', value: 'CustomerName' },
          { text: 'Telephone', value: 'Telephone1' },
          { text: 'Mobile', value: 'Mobile' },
          { text: 'Email', value: 'Email' }];
          break;
        }
      case SearchPageNames.CustomerContactSearch:
        {
          this.dropdownList = [{ text: 'Name', value: 'Name' }];
          break;
        }
      case SearchPageNames.DashboardDocumentsSearch: { break; }
      case SearchPageNames.DashboardNotepadSearch:
      case SearchPageNames.CustomerNotepad:
        {
          this.dropdownList = [{ text: 'Created', value: 'DateTimeCreated' },
          { text: 'Modified', value: 'DateTimeModified' }];
          break;
        }
      case SearchPageNames.DashboardAddressSearch:
        {
          this.dropdownList = [{ text: 'Address Code', value: 'AddressCode' },
          { text: 'City', value: 'City' },
          { text: 'County', value: 'County' },
          { text: 'Country', value: 'Country' },
          { text: 'Job Reference', value: 'JobRef' },
          { text: 'Contact Name', value: 'ContactName' }];
          break;
        }
      case SearchPageNames.CustomerProductsPurchased:
        {
          this.dropdownList = [{ text: 'Product Code', value: 'ProductCode' },
          { text: 'Order #', value: 'OrderNumber' },
          { text: 'Order Date', value: 'OrderDate' }];
          break;
        }
      case SearchPageNames.CustomerOpportunity:
      case SearchPageNames.DashboardOpportunitySearch:
        {
          this.dropdownList = [{ text: 'Created', value: 'DateTimeCreated' }];
          break;
        }
      case SearchPageNames.CustomerOrders:
        {
          this.dropdownList = [{ text: 'Order #', value: 'OrderNumber' },
          { text: 'Date Created', value: 'DateCreated' }];
          break;
        }
      case SearchPageNames.CustomerQuotes:
        {
          this.dropdownList = [{ text: 'Quote #', value: 'QuoteNumber' },
          { text: 'Date Created', value: 'DateCreated' }];
          break;
        }
      case SearchPageNames.CustomerTempOrders:
        {
          if (this.faDocumentService.fromDashbard) {
            this.dropdownList = [{ text: 'TemplateOrder #', value: 'TemplateOrderNumber' },
            { text: 'Date Created', value: 'DateCreated' }];
          }
          else {
            this.dropdownList = [{ text: 'Order #', value: 'OrderNumber' }];
          }
          break;
        }
      case SearchPageNames.CustomerCredit:
        {
          this.dropdownList = [{ text: 'Credit #', value: 'CreditNoteNumber' },
          { text: 'Job Ref asc., Credit Date', value: 'JobRef' },
          { text: 'Credit Date', value: 'CreditDate' }];
          break;
        }
      case SearchPageNames.CustomerInvoices:
        {
          this.dropdownList = [{ text: 'Invoice #', value: 'InvoiceNumber' },
          { text: 'Job Ref asc., Invoice Date', value: 'JobRef' },
          { text: 'Invoice Date', value: 'InvoiceDate' }];
          break;
        }
      case SearchPageNames.CustomerStatements:
        {
          this.dropdownList = [{ text: 'Statement #', value: 'StatementNumber' },
          { text: 'Generated', value: 'GeneratedDateTime' },
          { text: 'Closing Balance', value: 'ClosingBalance' }];
          break;
        }
      case SearchPageNames.DashboardStockTranferSearch:
        {
          this.dropdownList = [{ text: 'Stock Transfer #', value: 'OrderNumber' },
          { text: 'Date Required', value: 'DateRequired' }];
          break;
        }
      default: { break; }
    }
  }
}
